var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
// Override Settings
var boostPFSFilterConfig = {
    general: {
        limit: boostPFSThemeConfig.custom.products_per_page,
        /* Optional */
        loadProductFirst: false,
        numberFilterTree: 2,
        filterTreeMobileStyle: "style1",
    },
};

(function () {
    BoostPFS.inject(this);

    // Declare Templates
    var boostPFSTemplate = {
        // Grid Template
        productGridItemHtml:
            '<div data-vendor="{{bfsProductVendor}}" class="' +
            "{{itemSales}}" +
            " Grid__Cell 1/" +
            boostPFSThemeConfig.custom.mobile_row +
            "--phone 1/" +
            boostPFSThemeConfig.custom.tablet_row +
            "--tablet-and-up 1/" +
            boostPFSThemeConfig.custom.desktop_row +
            "--" +
            buildClass() +
            '">' +
            `<a href="{{bfsProductUrl}}" class="bfs-product-card bfs-image-hover">
              <div class="bfs-product-card__media bfs-media-wrapper">
                {{bfsProductImages}}
                <div class="bfs-product-card__info">
                  <div class="bfs-product-card__badges">{{bfsProductBadges}}</div>
                  <div class="bfs-product-card__wishlist"><button data-with-epi="true" class="swym-button swym-add-to-wishlist-view-product product_{{bfsProductId}}" data-swaction="addToWishlist" data-product-id="{{bfsProductId}}" data-variant-id="{{bfsVariantId}}" data-product-url="{{bfsProductUrl}}"></button></div>
                </div>
                <div class="bfs-product-card__bottom-info">{{bfsCfBadges}}</div>
              </div>
              <h4 class="bfs-product-card__title bfs-fs-a2">{{bfsProductTitle}}</h4>
              <p class="bfs-product-card__brand bfs-fs-b1">{{bfsBrandLabel}}</p>
              <div class="bfs-product-card__price bfs-fs-a2">{{bfsProductPrice}}</div>
              <ul class="bfs-product-card__variants bfs-fs-b1">{{bfsSizeOptions}}</ul>
            </a>` +
            "</div>",

        // Pagination Template
        previousActiveHtml:
            '<a class="Pagination__NavItem Link Link--primary" rel="prev" href="{{itemUrl}}"><svg class="{{ icon_class }}" role="presentation" viewBox="0 0 11 18"><path d="M9.5 1.5L1.5 9l8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path></svg></a>',
        previousDisabledHtml: "",
        nextActiveHtml:
            '<a class="Pagination__NavItem Link Link--primary" rel="next" href="{{itemUrl}}"><svg class="{{ icon_class }}" role="presentation" viewBox="0 0 11 18"><path d="M1.5 1.5l8 7.5-8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path> </svg></a>',
        nextDisabledHtml: "",
        pageItemHtml:
            '<a class="Pagination__NavItem Link Link--primary" href="{{itemUrl}}">{{itemTitle}}</a>',
        pageItemSelectedHtml:
            '<span class="Pagination__NavItem is-active">{{itemTitle}}</span>',
        pageItemRemainHtml:
            '<span class="Pagination__NavItem">{{itemTitle}}</span>',
        paginateHtml:
            ' <div class="Pagination Text--subdued"><div class="Pagination__Nav">{{previous}}{{pageItems}}{{next}}</div></div>',
        // Sorting Template
        sortingHtml: "{{sortingItems}}",
    };

    /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
    function prepareShopifyData(data) {
        /*Start of 86917*/
        var minPrice = 999999999;
        data.variants.forEach((v) => {
            if (v.available && v.price < minPrice) {
                minPrice = v.price;
            }
        });

        var obj = data.variants.find((v) => v.price == minPrice);

        if (obj) {
            data.price_min = parseFloat(minPrice);
            data.compare_at_price_min = parseFloat(obj.compare_at_price);
            if (obj.metafields) {
                data.metafields = obj.metafields;
            }
        }
        /*End of 86917*/

        // Displaying price base on the policy of Shopify, have to multiple by 100
        soldOut = !data.available; // Check a product is out of stock
        onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
        priceVaries = data.price_min != data.price_max; // Check a product has many prices
        // Convert images to array
        images = data.images_info;
        // Get First Variant (selected_or_first_available_variant)
        var firstVariant = data["variants"][0];
        if (Utils.getParam("variant") !== null && Utils.getParam("variant") != "") {
            var paramVariant = data.variants.filter(function (e) {
                return e.id == Utils.getParam("variant");
            });
            if (typeof paramVariant[0] !== "undefined")
                firstVariant = paramVariant[0];
        } else {
            for (var i = 0; i < data["variants"].length; i++) {
                if (data["variants"][i].available) {
                    firstVariant = data["variants"][i];
                    break;
                }
            }
        }

        return data;
    }

    /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
    /************************** BUILD PRODUCT LIST **************************/
    // Build Product Grid Item
    ProductGridItem.prototype.compileTemplate = function (data, index) {
        if (!data) data = this.data;
        if (!index) index = this.index;
        // Get Template
        var itemHtml = boostPFSTemplate.productGridItemHtml;
        if (
            data.handle.indexOf("sca_clone_freegift") !== -1 ||
            data.title.indexOf("% off") !== -1
        ) {
            itemHtml = "";
        }
        // Customize API data to get the Shopify data
        data = prepareShopifyData(data);

        itemHtml = itemHtml.replace(/{{bfsProductUrl}}/g, Utils.buildProductItemUrl(data));
        itemHtml = itemHtml.replace(/{{bfsProductImages}}/g, buildImages(data));
        itemHtml = itemHtml.replace(/{{bfsProductBadges}}/g, buildBadges(data));
        itemHtml = itemHtml.replace(/{{bfsCfBadges}}/g, buildCfBadges(data));
        itemHtml = itemHtml.replace(/{{bfsProductTitle}}/g, data.title);
        itemHtml = itemHtml.replace(/{{bfsProductPrice}}/g, buildPrice(data));
        itemHtml = itemHtml.replace(/{{bfsBrandLabel}}/g, buildBrandLabel(data));
        itemHtml = itemHtml.replace(/{{bfsProductId}}/g, data.id);
        itemHtml = itemHtml.replace(/{{bfsVariantId}}/g, data.variants[0].id);
        itemHtml = itemHtml.replace(/{{bfsSizeOptions}}/g, buildSizeOptions(data));
        itemHtml = itemHtml.replace(/{{bfsProductVendor}}/g, data.vendor);
        
        return itemHtml;
    };

    /************************** END BUILD PRODUCT LIST **************************/
    /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
    function buildClass() {
        return boostPFSThemeConfig.custom.filter_position == "drawer"
            ? "lap-and-up"
            : "desk";
    }

    function buildImages(data) {
        var html = "";

        if (data.images_info[0] !== undefined && data.images_info[0].src !== undefined && data.images_info[0].src !== "") {
            html += `
      <figure class="bfs-media">
        <picture class="bfs-media__inner bfs-media__inner--2-3">
            <img alt="${data.title}" class="bfs-media__img bfs-media--cover bfs-media--center" src="${data.images_info[0].src}" loading="lazy" decoding="async"/>
        </picture>
      </figure>
      `;
        }

        if (data.images_info[1] !== undefined && data.images_info[1].src !== undefined && data.images_info[1].src !== "") {
            html += `
      <figure class="bfs-media">
        <picture class="bfs-media__inner bfs-media__inner--2-3">
            <img alt="${data.title}" class="bfs-media__img bfs-media--cover bfs-media--center" src="${data.images_info[1].src}" loading="lazy" decoding="async"/>
        </picture>
      </figure>
      `;
        }

        return html;
    }

    function buildSizeOptions(data) {
        var html = "";
        var sizeOptionIndex = null;

        if (data.variants.length === 1 && data.variants[0].title === "Default Title") {
            return html;
        } else if (data.options.indexOf("size") > -1) {
            sizeOptionIndex = data.options.indexOf("size");
        } else if (data.options.indexOf("Size") > -1) {
            sizeOptionIndex = data.options.indexOf("Size");
        } else {
            return html;
        }

        data.variants.forEach(function (variant, index) {
            if (variant.available) {
                html += `<li>${variant.options[sizeOptionIndex]}</li>`;
            } else {
                html += `<li class="is-unavailable">${variant.options[sizeOptionIndex]}</li>`;
            }
        });

        return html;
    }

    function buildPrice(data) {
        var html = "";

        if (onSale) {
            html += `<span class="bfs-product-card__sale-price">${priceVaries ? "From&nbsp;" : ""}${Utils.formatMoney(data.price_min)}</span>`;
            html += `<span class="bfs-product-card__sale-compare-at-price"><s>${Utils.formatMoney(data.compare_at_price_min)}</s></span>`;
            var product_discount = data.compare_at_price_min - data.price_min;
            product_discount = (product_discount / data.compare_at_price_min) * 100;
            product_discount = Math.round(product_discount);
            if (product_discount > 0) {
                html += `<span class="bfs-product-card__sale-price">${product_discount}% OFF</span>`;
            }
        } else {
            html += `<span>${priceVaries ? "From&nbsp;" : ""}${Utils.formatMoney(data.price_min)}</span>`;
        }

        return html;
    }

    function buildBadges(data) {
        var html = "";

        if (data.tags.some(tag => tag.includes("NEW"))) {
            html += `<span class="bfs-badge bfs-badge--teal bfs-fs-b3">New</span>`;
        }

        if (onSale) {
            html += `<span class="bfs-badge bfs-badge--red bfs-fs-b3">On sale</span>`;
        }

        if (soldOut) {
            html += `<span class="bfs-badge bfs-badge--yellow bfs-fs-b3">Sold out</span>`;
        }

        if (data.tags.some(tag => tag.includes("preorder"))) {
            html += `<span class="bfs-badge bfs-badge--black bfs-fs-b3">Pre-order</span>`;
        }

        if (data.tags.some(tag => tag.includes("cotton")) || data.tags.some(tag => tag.includes("__badge:Cotton"))) {
            html += `<span class="bfs-badge bfs-badge--brown bfs-fs-b3">cotton</span>`;
        }

        if (data.tags.some((tag) => tag.includes("linen")) || data.tags.some((tag) => tag.includes("__badge:Linen"))) {
            html += `<span class="bfs-badge bfs-badge--sienna bfs-fs-b3">Linen</span>`;
        }

        if (data.tags.some((tag) => tag.includes("comingsoon")) || data.tags.some((tag) => tag.includes("__badge:Coming Soon"))) {
            html += `<span class="bfs-badge bfs-badge--orange bfs-fs-b3">Coming Soon</span>`;
        }

        if (data.tags.some(tag => tag.includes("recycled")) || data.tags.some(tag => tag.includes("RECYCLED"))) {
            html += `<span class="bfs-badge bfs-badge--light-green bfs-fs-b3">cotton</span>`;
        }

        if (data.tags.some(tag => tag.includes("__badge:2 Tees 3rd Free"))) {
            html += `<span class="bfs-badge bfs-badge--red bfs-fs-b3">2 Tees 3rd Free</span>`;
        }

        if (data.tags.some(tag => tag.includes("__label"))) {
            var customBadgeLabel = data.tags.find(tag => tag.includes("__label"));
            html += `<span class="bfs-badge bfs-badge--teal bfs-fs-b3">${customBadgeLabel.split("__label:")[1]}</span>`;
        }

        return html;
    }

    function buildCfBadges(data) {
        var html = "";
        var cfCustomLabel = data.metafields.find(({key}) => key === "custom_label");
        var cfCustomLabelBackground = data.metafields.find(({key}) => key === "custom_label_background");
        var cfCustomLabelFontColor = data.metafields.find(({key}) => key === "custom_label_font_color");

        if (cfCustomLabel !== undefined) {
            html += `<span class="bfs-badge bfs-badge--full bfs-fs-b3" style="background-color: ${cfCustomLabelBackground != undefined ? cfCustomLabelBackground.value : "#000"}; color: ${cfCustomLabelFontColor != undefined ? cfCustomLabelFontColor.value : "#fff"};">${cfCustomLabel.value}</span>`;
        } else if (window.collectionMetafields && window.collectionMetafields.custom_label) {
            html += `<span class="bfs-badge bfs-badge--full bfs-fs-b3" style="background-color: ${window.collectionMetafields.custom_label_background ? window.collectionMetafields.custom_label_background : "#000"}; color: ${window.collectionMetafields.custom_label_font_color ? window.collectionMetafields.custom_label_font_color : "#fff"};">${window.collectionMetafields.custom_label}</span>`;
        }

        return html;
    }

    function buildBrandLabel(data) {
        var html = "";

        if (data.tags.some(tag => tag.includes("BRAND_"))) {
            var customBrandLabel = data.tags.find(tag => tag.includes("BRAND_"));
            html += customBrandLabel.split("BRAND_")[1];
        }

        return html;
    }

    /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
    /************************** BUILD TOOLBAR **************************/
    // Build Pagination
    ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
        if (!totalProduct) totalProduct = this.totalProduct;
        // Get page info
        var currentPage = parseInt(Globals.queryParams.page);
        var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

        if (totalPage > 1) {
            var paginationHtml = boostPFSTemplate.paginateHtml;
            // Build Previous
            var previousHtml =
                currentPage > 1
                    ? boostPFSTemplate.previousActiveHtml
                    : boostPFSTemplate.previousDisabledHtml;
            previousHtml = previousHtml.replace(
                /{{itemUrl}}/g,
                Utils.buildToolbarLink("page", currentPage, currentPage - 1)
            );
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
            // Build Next
            var nextHtml =
                currentPage < totalPage
                    ? boostPFSTemplate.nextActiveHtml
                    : boostPFSTemplate.nextDisabledHtml;
            nextHtml = nextHtml.replace(
                /{{itemUrl}}/g,
                Utils.buildToolbarLink("page", currentPage, currentPage + 1)
            );
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
            // Create page items array
            var beforeCurrentPageArr = [];
            for (
                var iBefore = currentPage - 1;
                iBefore > currentPage - 3 && iBefore > 0;
                iBefore--
            ) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 4 > 0) {
                beforeCurrentPageArr.unshift("...");
            }
            if (currentPage - 4 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }
            beforeCurrentPageArr.push(currentPage);
            var afterCurrentPageArr = [];
            for (
                var iAfter = currentPage + 1;
                iAfter < currentPage + 3 && iAfter <= totalPage;
                iAfter++
            ) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 3 < totalPage) {
                afterCurrentPageArr.push("...");
            }
            if (currentPage + 3 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }
            // Build page items
            var pageItemsHtml = "";
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == "...") {
                    pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml +=
                        pageArr[iPage] == currentPage
                            ? boostPFSTemplate.pageItemSelectedHtml
                            : boostPFSTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(
                    /{{itemUrl}}/g,
                    Utils.buildToolbarLink("page", currentPage, pageArr[iPage])
                );
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
            return paginationHtml;
        }

        return "";
    };

    // Build Sorting
    ProductSorting.prototype.compileTemplate = function () {
        var html = "";
        if (
            boostPFSThemeConfig.custom.show_sorting &&
            boostPFSTemplate.hasOwnProperty("sortingHtml")
        ) {
            var sortingArr = Utils.getSortingList();
            if (sortingArr) {
                // Build content
                var sortingItemsHtml = "";
                for (var k in sortingArr) {
                    var classActive = Globals.queryParams.sort == k ? "is-selected" : "";
                    sortingItemsHtml +=
                        '<button class="Popover__Value ' +
                        classActive +
                        ' Heading Link Link--primary u-h6" data-value="' +
                        k +
                        '">' +
                        sortingArr[k] +
                        "</button>";
                }
                html = boostPFSTemplate.sortingHtml.replace(
                    /{{sortingItems}}/g,
                    sortingItemsHtml
                );
            }
        }
        return html;
    };

    // Build Sorting event
    ProductSorting.prototype.bindEvents = function () {
        var topSortingSelector = jQ(Selector.topSorting);
        topSortingSelector.find(".Popover__Value").click(function (e) {
            FilterApi.setParam("sort", jQ(this).data("value"));
            FilterApi.applyFilter("sort");
            jQ(".CollectionToolbar__Item--sort").trigger("click");
        });
    };
    /************************** END BUILD TOOLBAR **************************/

    // Add additional feature for product list, used commonly in customizing product list
    ProductList.prototype.afterRender = function (data, eventType) {
        if (!data) data = this.data;
        if (!eventType) eventType = this.eventType;
        /**
         *  Call theme function
         *  1. Add var bcPrestigeSections; var bcPrestigeSectionContainer; to assets/theme.min.js
         *  2. In assets/theme.min.js, find var YYY=new XXX.SectionContainer; For example: var e=new o.SectionContainer;
         *  3. Replace var e=new o.SectionContainer; by var e=new o.SectionContainer; var YYY = new XXX.SectionContainer;  bcPrestigeSections = YYY; bcPrestigeSectionContainer = XXX;

         if(typeof bcPrestigeSectionContainer != 'undefined' && typeof bcPrestigeSections != 'undefined'){
         bcPrestigeSections.register("collection", bcPrestigeSectionContainer.CollectionSection);
         bcPrestigeSections.register("search", bcPrestigeSectionContainer.SearchSection);
         }
         */

        // Fix image not load on Instagram browser - initialize swatch image
        jQ(
            ".ProductItem__Info .ProductItem__ColorSwatchList .ProductItem__ColorSwatchItem label.ColorSwatch"
        ).click(function () {
            jQ(this)
                .parent()
                .parent()
                .find("label.ColorSwatch")
                .removeClass("active");
            jQ(this).addClass("active");
            var parent = jQ(this).parent();
            var productImage = jQ(this)
                .parent()
                .parent()
                .parent()
                .parent()
                .find("a.ProductItem__ImageWrapper");
            var variantInfo = parent.find("input.ColorSwatch__Radio");
            productImage.find(".AspectRatio .bc-sf-product-swatch-img").remove();
            productImage
                .find(".AspectRatio")
                .prepend(
                    '<img class="bc-sf-product-swatch-img" src="' +
                    variantInfo.data("image-url") +
                    '" />'
                );
            productImage.find("img.ProductItem__Image").hide();
            productImage.attr("href", variantInfo.data("variant-url"));
            var variantPrice = "";
            if (
                variantInfo.data("variant-compare-at-price") >
                variantInfo.data("variant-price")
            ) {
                variantPrice +=
                    '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible="">' +
                    Utils.formatMoney(variantInfo.data("variant-price")) +
                    "</span>";
                variantPrice +=
                    '<span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible="">' +
                    Utils.formatMoney(variantInfo.data("variant-compare-at-price")) +
                    "</span>";
            } else {
                variantPrice +=
                    '<span class="ProductItem__Price Price Text--subdued test" data-money-convertible>' +
                    Utils.formatMoney(variantInfo.data("variant-price")) +
                    "</span>";
            }
            jQ(this)
                .closest(".ProductItem__Wrapper")
                .find(".ProductItem__PriceList")
                .html(variantPrice);
        });

        /** Start Swym integration **/
        window.SwymCallbacks = window.SwymCallbacks || [];
        window.SwymCallbacks.push(function (swat) {
            // Wrap with callback for loading without additional checks
            var products = [];
            data.forEach(function (product) {
                var image_src = Utils.getFeaturedImage(product.images_info);
                var productCopy = product;
                productCopy.featured_image = image_src;
                productCopy.price = product.price_min; // Sometimes I need to multiply the price with 100
                productCopy.compare_at_price = product.compare_at_price_min; // Sometimes I need to multiply the price with 100
                products.push(productCopy);
            });
            swat.mapShopifyProducts(products); // Product mapped data to swym layer
            swat.initializeActionButtons(".boost-pfs-filter-products"); // Buttons can now be initialized
        });
        /** End Swym integration **/
    };

    /*Start of 93129*/
    var collectionFilterLabels = [
        {
            original: "BEST SELLERS WOMEN'S CLOTHING",
            updated: "BEST SELLERS",
        },
        {
            original: "ACTIVEWEAR WOMEN'S",
            updated: "ACTIVEWEAR",
        },
        {
            original: "BOTTOMS WOMENS",
            updated: "BOTTOMS",
        },
        {
            original: "COATS & JACKETS WOMENS",
            updated: "COATS & JACKETS",
        },
        {
            original: "HOODIES & SWEATS WOMEN'S",
            updated: "HOODIES & SWEATS",
        },
        {
            original: "TOPS WOMEN'S",
            updated: "TOPS",
        },
        {
            original: "POLOS WOMEN'S",
            updated: "POLOS",
        },
        {
            original: "TEES WOMEN'S",
            updated: "TEES",
        },
        {
            original: "ACCESSORIES WOMEN'S",
            updated: "ACCESSORIES",
        },
        {
            original: "BEST SELLERS MEN'S CLOTHING",
            updated: "BEST SELLERS",
        },
        {
            original: "BOTTOMS MEN'S",
            updated: "BOTTOMS",
        },
        {
            original: "COATS & JACKETS MENS",
            updated: "COATS & JACKETS",
        },
        {
            original: "HOODIES & SWEATS MEN'S",
            updated: "HOODIES & SWEATS",
        },
        {
            original: "JERSEYS MEN'S",
            updated: "JERSEYS",
        },
        {
            original: "POLOS MEN'S",
            updated: "POLOS",
        },
        {
            original: "SINGLETS / TANKS MEN'S",
            updated: "SINGLETS / TANKS",
        },
        {
            original: "SHIRTS MEN´S",
            updated: "SHIRTS",
        },
        {
            original: "TEES MEN'S",
            updated: "TEES",
        },
        {
            original: "ACCESSORIES MEN'S",
            updated: "ACCESSORIES",
        },
        {
            original: "BEST SELLERS KIDS CLOTHING",
            updated: "BEST SELLERS",
        },
        {
            original: "POLOS KID'S",
            updated: "POLOS",
        },
        {
            original: "TEES KID'S",
            updated: "TEES",
        },
        {
            original: "KIDS FACE MASKS",
            updated: "FACE MASKS",
        },
        {
            original: "LEGGINGS KIDS",
            updated: "LEGGINGS",
        },
        {
            original: "HALLOWEEN ACCESSORIES MEN'S",
            updated: "ACCESSORIES MEN'S",
        },
        {
            original: "HALLOWEEN BAGS",
            updated: "BAGS",
        },
        {
            original: "HALLOWEEN BOTTOMS WOMEN'S",
            updated: "BOTTOMS WOMEN'S",
        },
        {
            original: "HALLOWEEN DRESSES",
            updated: "DRESSES",
        },
        {
            original: "HALLOWEEN DRINKWARE",
            updated: "DRINKWARE",
        },
        {
            original: "HALLOWEEN GIFT PACK / BUNDLES",
            updated: "GIFT PACK / BUNDLES",
        },
        {
            original: "HALLOWEEN HEADWEAR",
            updated: "HEADWEAR",
        },
        {
            original: "HALLOWEEN JERSEYS",
            updated: "JERSEYS",
        },
        {
            original: "HALLOWEEN JEWELLERY",
            updated: "JEWELLERY",
        },
        {
            original: "HALLOWEEN POLOS KIDS",
            updated: "POLOS KIDS",
        },
        {
            original: "HALLOWEEN POLOS MEN'S",
            updated: "POLOS MEN'S",
        },
        {
            original: "HALLOWEEN POLOS WOMEN'S",
            updated: "POLOS WOMEN'S",
        },
        {
            original: "HALLOWEEN SCARVES",
            updated: "SCARVES",
        },
        {
            original: "HALLOWEEN SHAWLS",
            updated: "SHAWLS",
        },
        {
            original: "HALLOWEEN SINGLETS",
            updated: "SINGLETS",
        },
        {
            original: "HALLOWEEN SUIT ACCESSORIES",
            updated: "SUIT ACCESSORIES",
        },
        {
            original: "POLO SHIRTS WOMEN'S",
            updated: "POLO SHIRTS",
        },
        {
            original: "T-SHIRTS WOMENS",
            updated: "T-SHIRTS",
        },
        {
            original: "POLO SHIRTS MEN'S",
            updated: "POLO SHIRTS",
        },
        {
            original: "T-SHIRTS MENS",
            updated: "T-SHIRTS",
        },
        {
            original: "POLO SHIRTS KIDS",
            updated: "POLO SHIRTS",
        },
        {
            original: "T-SHIRTS KIDS",
            updated: "T-SHIRTS",
        },
        {
            original: "ALL ABORIGINAL ART WOMEN'S CLOTHING",
            updated: "ALL WOMEN'S CLOTHING",
        },
        {
            original: "ALL ABORIGINAL ART MEN'S CLOTHING",
            updated: "ALL MEN'S CLOTHING",
        },
        {
            original: "BEST SELLERS ABORIGINAL ART WOMEN'S CLOTHING",
            updated: "BEST SELLERS",
        },
        {
            original: "BEST SELLERS ABORIGINAL ART MEN'S CLOTHING",
            updated: "BEST SELLERS",
        },
        {
            original: "ABORIGINAL ART",
            updated: "",
        },
    ];

    FilterOptionItem.prototype.buildLabel = function () {
        var filterOption = this.filterOption ? this.filterOption : this.parent;

        var label = this.label;
        var prefix = filterOption.prefix;

        if (typeof label != "string") return "";

        // Remove Prefix
        if (typeof prefix == "string") {
            prefix = prefix.replace(/\\/g, "");
            label = label.replace(prefix, "").trim();
        }
        label = decodeHtml(label);
        if (
            this.parent.filterOptionId == "pf_c_collection" &&
            collectionFilterLabels
        ) {
            collectionFilterLabels.forEach((l) => {
                //if (label == l.original) label = l.updated;
                if (label == l.original) {
                    label = l.updated;
                } else if (label.includes("BOXING D.")) {
                    label = label.replace(/BOXING D./g, "");
                } else if (label.includes("HOLIDAY SALE - ")) {
                    label = label.replace("HOLIDAY SALE - ", "");
                } else if (label.includes(".")) {
                    label = label.replace(".", "");
                }
            });
        }
        // No capital label of Rating filter option
        if (label.indexOf("boost-pfs-filter-icon-star") > -1) return label;

        // Make the text to uppercase
        filterOption.displayAllValuesInUppercaseForm =
            filterOption.displayAllValuesInUppercaseForm || false;
        if (filterOption.displayAllValuesInUppercaseForm)
            return label.toUpperCase();

        // Make all letters lowercase first, then capitalize all first letters of each string in a filter option value
        // For example: HELLO World => Hello World
        if (Settings.getSettingValue("general.forceCapitalizeFilterOptionValues"))
            return Utils.capitalize(label, true);

        // Make all letters lowercase first, then capitalize first letter of a filter option value
        // For example: product fILTER => Product filter
        if (
            Settings.getSettingValue(
                "general.capitalizeFirstLetterFilterOptionValues"
            )
        )
            return Utils.capitalize(label, true, true);

        // Just capitalize first letter and don't change the format of any other letters
        // For example: hello wORLD => Hello WORLD
        if (Settings.getSettingValue("general.capitalizeFilterOptionValues"))
            return Utils.capitalize(label);

        // return label
        return label;
    };

    PageInfoCollection.prototype.buildCollectionDetail = function () {
        if (
            typeof this.collectionData !== "undefined" &&
            this.collectionData.hasOwnProperty("collection")
        ) {
            // Get collection info
            var collectionInfo = this.collectionData.collection;
            var title =
                collectionInfo.hasOwnProperty("title") && collectionInfo.title != ""
                    ? collectionInfo.title
                    : null;
            var description =
                collectionInfo.hasOwnProperty("description") &&
                collectionInfo.description != ""
                    ? collectionInfo.description
                    : null;
            var image =
                collectionInfo.hasOwnProperty("image") &&
                collectionInfo.image &&
                collectionInfo.image.src
                    ? collectionInfo.image.src
                    : null;
            // Build Collection Title
            collectionFilterLabels.forEach((l) => {
                if (title == l.original) title = l.updated;
            });
            if (title) {
                this.$collectionHeader.html(title).show();
            } else {
                this.$collectionHeader.hide();
            }
            // Build Collection Description
            if (description) {
                this.$collectionDescription.html(description).show();
            } else {
                this.$collectionDescription.hide();
            }
            // Build Collection Image
            if (image) {
                this.$collectionImage
                    .attr("src", image)
                    .css("background-image", "url(" + image + ")")
                    .removeClass(Class.collectionNoImage)
                    .addClass(Class.collectionHasImage);
            } else {
                this.$collectionImage
                    .attr(
                        "src",
                        "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                    )
                    .css("background-image", "none")
                    .removeClass(Class.collectionHasImage)
                    .addClass(Class.collectionNoImage);
            }
        }
    };

    // Build additional elements
    FilterResult.prototype.afterRender = function (data, eventType) {
        if (!data) data = this.data;
        if (!eventType) eventType = this.eventType;

        if (eventType == "init") {
            var currentCollectionTitle = jQ(
                ".CollectionInner__Sidebar .boost-pfs-filter-collection-header"
            ).text();
            var newCollectionTitle = currentCollectionTitle;
            collectionFilterLabels.forEach((l) => {
                if (currentCollectionTitle == l.original)
                    newCollectionTitle = l.updated;
            });
            jQ(".CollectionInner__Sidebar .boost-pfs-filter-collection-header").html(
                newCollectionTitle
            );
        }
    };

    function decodeHtml(html) {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    }

    /*End of 93129*/

    /*Start of 149788 */
    var applyFilter = FilterApi.applyFilter;
    FilterApi.applyFilter = function (eventType, eventInfo) {
        if (eventType !== "collection")
            applyFilter.call(this, eventType, eventInfo);
        else {
            var url = Navigation.buildAddressBarUrl();
            window.location = url;
        }
    };
    /*End of 149788 */

    // Build Default layout
    Filter.prototype.errorFilterCallback = function () {
        if (
            !Utils.isiOS() &&
            !Utils.isSafari() &&
            !Utils.isBackButton() &&
            !Utils.getWindowLocation().href.includes("view=boost-pfs-original")
        ) {
            var url = Utils.getWindowLocation().href.split("?")[0];
            var searchQuery =
                Utils.isSearchPage() && Globals.queryParams.hasOwnProperty("q")
                    ? "&q=" + Globals.queryParams.q
                    : "";
            var newUrl = url + "?view=boost-pfs-original" + searchQuery;
            if (!Utils.isBadUrl(newUrl)) {
                window.location.href = newUrl;
            }
        }
    };
})();
